export enum EGameVariant {
  ROULETTE = 'roulette',
  RUSSIAN_POKER = 'russianPoker',
}

export const gameVariants: {
  [key: string]: string
} = {
  [EGameVariant.ROULETTE]: 'Рулетка',
  [EGameVariant.RUSSIAN_POKER]: 'Русский покер',
}
